import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import * as ShowSelectors from "@app/shared/state/show/show.selectors";
import { ExternalVideo } from "@app/models/external-video";

@Injectable({
  providedIn: "root",
})
export class VideoShowService {
  supplierIsInShow: boolean;
  videos: ExternalVideo[] = [
    {
      title: "Show Features Overview",
      vimeoId: "1115184078/98fd85dc88",
      backgroundUrl: "https://i.vimeocdn.com/video/896046219_640.webp",
      group: null,
    },
  ];

  constructor(private _store: Store) {
    this._store
      .select(ShowSelectors.selectIsSupplierInShow)
      .subscribe((val) => (this.supplierIsInShow = val));
  }

  public getCurrentVideos(): ExternalVideo[] {
    return this.videos;
  }
}
